import { Injectable } from '@angular/core';

import {
  HttpClient
}
  from '@angular/common/http';

import {
  Observable
}
  from 'rxjs';

@Injectable({

  providedIn: 'root'

})

export class FlyingbeesService {



  API = "https://ipromisesolutions.com/api_folder/";

  constructor(

    private http: HttpClient

  ) { }

  /* FULL CONTACT */

  ContactFrm(

    name: string,

    email: string,

    phone_number: string,

    message: string = ''

  ): Observable<any> {

    const url =

      this.API +

      'create_new_whatsapp.php';

    const formData =
      new FormData();

    formData.append(
      'name',
      name || ''
    );

    formData.append(
      'email',
      email || ''
    );

    formData.append(
      'phone_number',
      phone_number || ''
    );

    formData.append(
      'message',
      message || ''
    );

    return this.http.post(
      url,
      formData
    );

  }

  /* SHORT FORM */

  ContactFrm2(

    name: string,

    phone_number: string

  ): Observable<any> {

    const url =

      this.API +

      'create_new_whatsapp.php';

    const formData =
      new FormData();

    formData.append(
      'name',
      name || ''
    );

    /* REQUIRED FIELD */

    formData.append(
      'email',
      'sathish13cs@gmail.com'
    );

    formData.append(
      'phone_number',
      phone_number || ''
    );

    formData.append(
      'message',
      ''
    );

    return this.http.post(
      url,
      formData
    );

  }
  CheckPassword(

    password: string

  ) {

    const formData =
      new FormData();

    formData.append(

      'user_password',

      password

    );

    return this.http.post(

      this.API +

      'check_password.php',

      formData

    );

  }
}